import "./App.css";
import React, { useEffect, useRef, useState } from "react"
import Chatbot from "./ChatBot/Body/Chatbot";
import { fetchAppModules } from "./Api";

function App() {
  const hasFetched = useRef(false);
  const [appModulesData, setAppModulesData] = useState<any>(null);

  useEffect(() => {
    // Prevent duplicate API calls in React.StrictMode (development)
    if (hasFetched.current) return;
    hasFetched.current = true;

    fetchAppModules((data: any) => {
      // Handle the app modules data here
      console.log("App modules loaded:", data);
      setAppModulesData(data);
    });
  }, []);

  return (
    <div
      style={{
        position: "relative",
        // width: "100%",
        display: "flex",
        justifyContent: "center",
        height:"100%"
      }}
    >
      <Chatbot appModulesData={appModulesData} />
    </div>
  );
}

export default App;
